import { AxiosResponse } from "axios";

export type AIAssistantApiError = {
  error: string;
  reason: {
    request_count: number;
    allowed_count: number;
    count_reset_date: string;
    user_id: string;
  };
};

export function isAIAssistantApiError(error: unknown): error is AxiosResponse<{
  message: AIAssistantApiError;
  result: string;
}> {
  return !!(
    error &&
    typeof error === "object" &&
    "data" in error &&
    error.data &&
    typeof error.data === "object" &&
    "message" in error.data &&
    "result" in error.data
  );
}
